// @flow

export {
  default as POIObject,
  useViewModelForObject,
  useViewModelForObjects,
  viewModelForObject,
} from './POIObject';
export { default as POIObjectList } from './POIObjectList';
